export default "__VITE_ASSET__CYofPlnr__"